import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtTeamScorecardChartItem {
    bandID: number;
    bandName: string;
    usersInBand: number;
    perInBand: number;
    totalScoreCards: number;
}

interface TeamScorecardChartItem {
    bandName: string;
    usersInBand: number;
}

export interface TeamScorecardChart {
    d3: { options?: any; data: any };
}

class TeamScorecardChartItemModelTransformer
    implements
        ModelTransformer<TeamScorecardChartItem, ExtTeamScorecardChartItem>
{
    transform(model: ExtTeamScorecardChartItem): TeamScorecardChartItem {
        return {
            bandName: model.bandName,
            usersInBand: model.usersInBand,
        };
    }
}

class TeamScorecardChartItemModelSetTransformer extends ModelSetTransformer<
    TeamScorecardChartItem,
    ExtTeamScorecardChartItem
> {
    protected newTransformer(): ModelTransformer<
        TeamScorecardChartItem,
        ExtTeamScorecardChartItem
    > {
        return new TeamScorecardChartItemModelTransformer();
    }
}

export class TeamScorecardChartModelTransformer
    implements
        ModelTransformer<TeamScorecardChart, ExtTeamScorecardChartItem[]>
{
    transform(model: ExtTeamScorecardChartItem[]): TeamScorecardChart {
        const items = new TeamScorecardChartItemModelSetTransformer().transform(
            model,
        );
        return {
            d3: {
                data: [
                    {
                        color: '#1f77b4',
                        values: items.reverse().map((value) => {
                            return {
                                x: value.bandName,
                                y: value.usersInBand,
                            };
                        }),
                    },
                ],
            },
        };
    }
}

export function validateTeamScorecardChart(model: TeamScorecardChart): void {
    const valid = model != null && model.d3.data[0].values.length !== 0;
    if (!valid) {
        throw new Error('TeamScorecardChart not valid');
    }
}
